import humanizeDuration from "humanize-duration";
import { type ClassValue, clsx } from 'clsx';
import forge from 'node-forge';
import CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';
import { Dispatch, SetStateAction } from "react";

export function TweleveHourFormat(values: string) {
  let hours: any = values.split(":")?.[0]; // gives the value in 24 hours format
  const AmOrPm = Number(hours) >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;
  const minutes = values.split(":")?.[1]; // gives the value in 24 hours format
  return `${hours + ":" + minutes + " " + AmOrPm}`;
}


export function capitalize(str:string) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export enum IllegalActivityEnum {
  allTabPress = "allTabPress",
  windowsD = "windowsD",
  windowsM = "windowsD",
  windows = "windows",
  alt = "alt",
}

export const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

const successNotificationRequest = () => {
  window.location.reload();
  setTimeout(() => {
    new Notification("Notifications are enabled", {
      body: "Notifications will be used to alert you during illegal activities",
      icon: "/images__1_-removebg-preview.png",
      dir: "ltr",
    });
  }, 3000);
};

let count = 0;

// export const requestNotificationCallback = () => {
//
//

//   if (count === 3) return;
//   if (Notification.permission === "denied") {
//     Swal.fire({
//       title: "Please enable notifications",
//       icon: "warning",
//       text: `You need to enable notifications to for the
//             best experience`,
//       confirmButtonText: "Allow",
//       showClass: {
//         popup: `
//             animate__animated
//             animate__fadeInUp
//             animate__faster
//           `,
//       },
//       hideClass: {
//         popup: `
//             animate__animated
//             animate__fadeOutDown
//             animate__faster
//           `,
//       },
//     }).then((result) => {
//       if (result.isConfirmed) {
//         if (!("Notification" in window)) {
//           Swal.fire({
//             title: "Notifications are not supported",
//             icon: "error",
//             html: `This browser does not support desktop notification.<br/>Notification will be used to notify you during illegal activities in your exams `,
//             footer: "Please try another browser",
//           });
//         } else if (Notification.permission === "granted") {
//           // If it's okay let's create a notification
//           successNotificationRequest();
//         } else if (Notification.permission === "denied") {
//
//           Notification.requestPermission(function (permission) {
//
//
//             // Whatever the user answers, we make sure we store the information
//             if (!("permission" in Notification)) {
//               // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//               // @ts-ignore
//               Notification.permission = permission;
//             }

//             // If the user is okay, let's create a notification
//             if (permission === "granted") {
//               successNotificationRequest();
//             }
//           });
//         } else {
//           requestNotificationCallback();
//         }
//       }
//     });
//   }

//   if (Notification.permission !== "granted") Notification.requestPermission();
// };

// export const requestWebNotification = () => {
//   document.addEventListener("DOMContentLoaded", requestNotificationCallback);
// };

// export const clearWebNotification = () => {
//   document.removeEventListener("DOMContentLoaded", requestNotificationCallback);
// };

export const Utilfilesizes = (bytes: any, decimals: number = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

// Shuffle function using Fisher-Yates algorithm
export const shuffleImages = (imagesList: Array<any>) => {
  const shuffled = [...imagesList];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export function downloadBase64PDF(base64Data: any, filename = "file.pdf") {
  const decoded = decodeURIComponent(escape(atob(base64Data)));
  const linkSource = `data:application/pdf;base64,${decoded}`;
  const downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = filename;
  downloadLink.click();
}

// const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
// MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHZfOr1pWpI+lZNZJXtvUG5TV1
// qRTQimh495h3q33ycGyCG1Aor+Qlug05Bm8jhAzbTlX3iuk16119W9F71KoJjo+D
// mNW35UeKE72109UfGqcFWp7kvOKGCUihQBvK2teML2dO48+D7RD805eL9i3SDu+6
// 0Ckn1oKDff2He/PbUQIDAQAB
// -----END PUBLIC KEY-----`;

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHZfOr1pWpI+lZNZJXtvUG5TV1
qRTQimh495h3q33ycGyCG1Aor+Qlug05Bm8jhAzbTlX3iuk16119W9F71KoJjo+D
mNW35UeKE72109UfGqcFWp7kvOKGCUihQBvK2teML2dO48+D7RD805eL9i3SDu+6
0Ckn1oKDff2He/PbUQIDAQAB
-----END PUBLIC KEY-----`;

export function encryptWithFixedKey(data: any) {
  data = typeof data === "string" ? data : JSON.stringify(data);
  const aesKey = CryptoJS.lib.WordArray.random(32); // 256-bit
  const iv = CryptoJS.lib.WordArray.random(16); // 128-bit

  const encryptedData = CryptoJS.AES.encrypt(data, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  const aesKeyBase64 = CryptoJS.enc.Base64.stringify(aesKey);
  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(PUBLIC_KEY);

  const encryptedKey = encryptor.encrypt(aesKeyBase64);
  const encryptedIv = encryptor.encrypt(ivBase64);

  return {
    encrypted_data: encryptedData,
    encrypted_key: encryptedKey,
    encrypted_iv: encryptedIv,
  };
}

export function generateRandomBytes() {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  [...new Array(32)].forEach((self) => {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  });

  return result;
}
export function decryptWithFixedKey(
  encryptedData: {
    encrypted_data: string;
    encrypted_key: string;
    encrypted_iv: string;
  },
  privateKey: string
): any {
  // Decrypt the AES key and IV using RSA private key
  const decryptor = new JSEncrypt();
  decryptor.setPrivateKey(privateKey);

  const aesKeyBase64 = decryptor.decrypt(encryptedData.encrypted_key);
  const ivBase64 = decryptor.decrypt(encryptedData.encrypted_iv);

  if (!aesKeyBase64 || !ivBase64) {
    throw new Error("Failed to decrypt AES key or IV");
  }

  // Convert Base64 strings back to WordArrays
  const aesKey = CryptoJS.enc.Base64.parse(aesKeyBase64);
  const iv = CryptoJS.enc.Base64.parse(ivBase64);

  // Decrypt the data
  const decrypted = CryptoJS.AES.decrypt(encryptedData.encrypted_data, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Convert to UTF-8 string
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);

  // Try to parse as JSON, return as string if not parseable
  try {
    return JSON.parse(decryptedStr);
  } catch (e) {
    return decryptedStr;
  }
}

export function decryptAES256(
  encryptedData: {
    encrypted_data: string;
    encrypted_key: string;
    encrypted_iv: string;
  },
  privateKey: string
): any {
  try {
    const decryptor = new JSEncrypt();
    decryptor.setPrivateKey(privateKey);

    const aesKeyBase64 = decryptor.decrypt(encryptedData.encrypted_key);
    const ivBase64 = decryptor.decrypt(encryptedData.encrypted_iv);

    if (!aesKeyBase64 || !ivBase64) {
      throw new Error("Failed to decrypt AES key or IV");
    }

    const aesKey = CryptoJS.enc.Base64.parse(aesKeyBase64);
    const iv = CryptoJS.enc.Base64.parse(ivBase64);

    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedData.encrypted_data,
      aesKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedStr = decryptedBytes.toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decryptedStr);
    } catch (e) {
      return decryptedStr;
    }
  } catch (error) {
    throw new Error("Decryption failed");
  }
}

export async function decryptAES256CBC2(
  base64Ciphertext: string,
  base64Key: string
): Promise<string> {
  // Decode Base64 inputs
  const ciphertextBytes = forge.util.decode64(base64Ciphertext);
  const keyBytes = forge.util.decode64(base64Key);

  // Ensure key is 32 bytes (AES-256 requirement)
  if (keyBytes.length !== 32) {
    throw new Error("Key must be 32 bytes (256 bits) for AES-256");
  }

  // Extract IV (first 16 bytes) and actual ciphertext
  const iv = ciphertextBytes.substring(0, 16);
  const encryptedData = ciphertextBytes.substring(16);

  // Create decipher (explicitly using AES-256-CBC)
  const decipher = forge.cipher.createDecipher(
    "AES-CBC", // Still uses 'AES-CBC', but key size determines AES-128/192/256
    forge.util.createBuffer(keyBytes)
  );

  // Configure decipher
  decipher.start({ iv: forge.util.createBuffer(iv) });
  decipher.update(forge.util.createBuffer(encryptedData));
  decipher.finish();

  // Return decrypted UTF-8 string
  return decipher.output.toString();
}

export async function decryptAES256CBC(
  base64Ciphertext: string,
  base64Key: string
): Promise<any> {
  // Convert Base64 ciphertext and key to byte arrays
  const ciphertextBytes = Uint8Array.from(atob(base64Ciphertext), (c) =>
    c.charCodeAt(0)
  );
  const keyBytes = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));

  // Extract IV (first 16 bytes) and actual ciphertext
  const iv = ciphertextBytes.slice(0, 16);
  const actualCiphertext = ciphertextBytes.slice(16);

  // Import key
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );

  // Decrypt
  const decryptedBuffer = await crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv: iv,
    },
    cryptoKey,
    actualCiphertext
  );

  const decoder = new TextDecoder();
  return decoder.decode(decryptedBuffer);
}

export async function isCameraAvailable(): Promise<boolean> {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return false;
  }

  let stream: MediaStream | null = null;

  try {
    // Request camera access
    stream = await navigator.mediaDevices.getUserMedia({ video: true });

    // Check for video input devices
    const devices = await navigator.mediaDevices.enumerateDevices();
    const hasCamera = devices.some((device) => device.kind === "videoinput");

    // Stop all tracks immediately
    stream.getTracks().forEach((track) => {
      if (track.readyState === "live") {
        track.stop();
      }
    });

    return hasCamera;
  } catch (err) {
    return false;
  }
}

export const base64toBlob = (base64: any) => {
  const parts = base64.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export function convertToISOFormat(input: any) {
  const [datePart, timePart] = input.split(" ");
  const [day, month, year] = datePart.split("-");
  return `${year}-${month}-${day} ${timePart}`;
}

export function formatDateTime(input: string): {
  date: string;
  time: string;
} {
  const [datePart, timePart] = input.split(" ");
  const [day, month, year] = datePart.split("-");

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Format the date
  const formattedDate = `${day}-${month}-${year}`;

  // Format the time to 12-hour format
  let [hour, minute, second]: any = timePart.split(":");
  hour = parseInt(hour, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  //hour = hour % 12 || 12; // Convert 0 -> 12
  const formattedTime = `${hour
    .toString()
    .padStart(2, "0")}:${minute}:${second} ${ampm}`;

  return {
    date: formattedDate,
    time: formattedTime,
  };
}

export function startClockFromInput({
  input,
  setInput,
}: {
  input: {
    date: string;
    time: string;
  };
  setInput: any;
}) {
  function formatDateTime(dateObj: any) {
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const hours24 = dateObj.getHours();

    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    const ampm = hours24 >= 12 ? "PM" : "AM";
    const hours12 = String(hours24).padStart(2, "0");

    return {
      date: `${day}-${month}-${year}`,
      time: `${hours12}:${minutes}:${seconds} ${ampm}`,
    };
  }

  // Parse the input string
  const datePart = input.date;

  const timePart = input.time;
  const [day, month, year] = datePart.split("-").map(Number);

  const [hours, minutes, seconds] = timePart.split(":").map(Number);

  // Create initial date object
  let currentDate = new Date(year, month - 1, day, hours, minutes);

  // Start the interval
  const timer = setInterval(() => {
    currentDate.setSeconds(currentDate.getSeconds() + 1);
    const result = formatDateTime(currentDate);

    setInput(result);
  }, 1000);
  return timer;
}

export function convertTo24Hour(time12h: any) {
  const [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier.toUpperCase() === "PM") {
    hours = String(parseInt(hours, 10) + 12);
  }

  return `${hours.padStart(2, "0")}:${minutes}`;
}

export function convertTo12Hour(time24: any) {
  let [hours, minutes, seconds] = time24.split(":").map(Number);
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  return `${hours}:${String(minutes).padStart(2, "0")}:${String(
    seconds
  ).padStart(2, "0")} ${ampm}`;
}

export function getTimeDifference(d1: any, d2: any) {
  // Get absolute difference in milliseconds
  const diffMs = Math.abs(d1 - d2);

  // Convert to seconds
  let totalSeconds = Math.floor(diffMs / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  // Format as hh:mm:ss
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:${String(seconds).padStart(2, "0")}`;
}

export function formatToExamDateTime(input: any) {
  const dateObj = new Date(input); // Accepts Date object or date string

  const date = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  return {
    date: `${date}-${month}-${year}`,
    time: `${hours}:${minutes}:${seconds}`,
  };
}



export function base64ToString(base64:any) {
  return decodeURIComponent(
    Array.prototype.map.call(atob(base64), c =>
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join('')
  );
}


